<template lang="pug">
  component(:is="flaggedComponent" v-bind="$props" v-on="$attrs" ref="intentComponent" )
</template>

<script>
import get from 'lodash/get';
import IntentsOld from './IntentsOld.vue';
import IntentsNew from './IntentsNew.vue';
import { mapState } from 'vuex';
import { confirmDiscardUnsavedChanges } from '@/libs';

export default {
  name: 'IntentsWrapper',
  components: {
    IntentsOld,
    IntentsNew,
  },
  computed: {
    ...mapState({
      featureFlags: state => state.featureFlags.FEATURE_FLAGS,
    }),
    flaggedComponent() {
      return this.featureFlags?.SHOW_NEW_INTENT_DESIGN ? IntentsNew : IntentsOld;
    },
  },
  async beforeRouteLeave(to, from, next) {
    // Same route (e.g. menu link to /iqtools/intents when already there): no need to confirm
    if (to.name === from.name) {
      return next();
    }
    // Tab switch within Intents section: layout's before-leave already showed the confirm, so don't show again
    const isMatched = (item) => item.matched.some(r => r.name === 'Intents');
    const stayingInIntentsSection = isMatched(to) && isMatched(from);
    if (stayingInIntentsSection) {
      return next();
    }

    const childComponent = this.$refs.intentComponent;

    // Only check for unsaved changes if we're in edit mode and have changes
    if (get(childComponent, 'isEditMode') && get(childComponent, 'isChanged')) {
      const confirmedDiscard = await confirmDiscardUnsavedChanges(this);
      return next(confirmedDiscard);
    }

    return next();
  },
};
</script>
